import { Action } from 'redux';
// Import States.
import {
	AppState,
	PolicyState,
	PublicPolicyViewState,
	getInitialPublicPolicyViewState,
} from '@app/redux/states';
// Import Actions.
import {
	ClearPublicPolicyViewDataAction,
	PublicPolicyViewAction,
	LoadPublicPolicyViewDataAction,
	LoadPublicPolicyTermsWithStatusAction,
} from '@app/redux/actions';
// Import state initializers.
import {
	initializePolicyState
} from '@app/redux/reducers/initializers';
// Import state queries.
import {
	queryPolicyState,
} from '@app/redux/reducers/queries';
// Import api models.
import {
	PublicPolicyViewData,
	PolicyTermWithStatus,
} from '@app/models/api';

/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState, action: PublicPolicyViewAction): AppState => {
	let newState: AppState = { ...state };
	// Initialize the parent state.
	newState = initializePolicyState(newState, action);
	// Query the parent state.
	let policyState: PolicyState = queryPolicyState(newState, action);
	// Initialize the state.
	if (!policyState.publicPolicyView) {
		policyState.publicPolicyView = getInitialPublicPolicyViewState();
	}
	else {
		policyState.publicPolicyView = { ...policyState.publicPolicyView };
	}
	return newState;
}

/**
 * Query the state.
 * @param state
 * @param action
 */
let queryPublicPolicyViewState = (state: AppState, action: PublicPolicyViewAction): PublicPolicyViewState => {
	return queryPolicyState(state, action).publicPolicyView;
}


// Clear Public Policy View Data Reducer.

let ClearPublicPolicyViewDataReducer = (state: AppState, action: Action): AppState => {
	let loadPublicPolicyViewDataAction: ClearPublicPolicyViewDataAction = action as ClearPublicPolicyViewDataAction;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadPublicPolicyViewDataAction);

	// Query the state.
	let policyState: PolicyState = queryPolicyState(newState, loadPublicPolicyViewDataAction);

	policyState.publicPolicyView = getInitialPublicPolicyViewState();

	return newState;
}

// Load Public Policy View Data Reducer.

let LoadPublicPolicyViewDataReducer = (state: AppState, action: Action): AppState => {
	let loadPublicPolicyViewDataAction: LoadPublicPolicyViewDataAction = action as LoadPublicPolicyViewDataAction;
	let publicPolicyViewData: PublicPolicyViewData = loadPublicPolicyViewDataAction.publicPolicyViewData;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadPublicPolicyViewDataAction);

	// Query the state.
	let publicPolicyViewState: PublicPolicyViewState = queryPublicPolicyViewState(newState, loadPublicPolicyViewDataAction);

	publicPolicyViewState.publicPolicyViewData = publicPolicyViewData;
	publicPolicyViewState.isPublicPolicyViewDataLoaded = true;

	return newState;
}

// Load Public Policy Terms With Status Reducer.

let LoadPublicPolicyTermsWithStatusReducer = (state: AppState, action: Action): AppState => {
	let loadPublicPolicyTermsWithStatusAction: LoadPublicPolicyTermsWithStatusAction = action as LoadPublicPolicyTermsWithStatusAction;
	let publicPolicyTermsWithStatus: PolicyTermWithStatus[] = loadPublicPolicyTermsWithStatusAction.publicPolicyTermsWithStatus;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadPublicPolicyTermsWithStatusAction);

	// Query the state.
	let publicPolicyViewState: PublicPolicyViewState = queryPublicPolicyViewState(newState, loadPublicPolicyTermsWithStatusAction);

	publicPolicyViewState.publicPolicyTermsWithStatus = publicPolicyTermsWithStatus;
	publicPolicyViewState.arePublicPolicyTermsWithStatusLoaded = true;

	return newState;
}

// Export reducers.
export {
	ClearPublicPolicyViewDataReducer,
	LoadPublicPolicyViewDataReducer,
	LoadPublicPolicyTermsWithStatusReducer,
};

// Export initializers.
export {
	initializeState
}

// Export queries.
export {
	queryPublicPolicyViewState
};